import { createSvgIcon } from '@material-ui/core/utils';

export const CreateIcon = createSvgIcon(
  <>
    <path d="M17.38 2.67H6.62L1.23 12l5.39 9.32h10.76L22.77 12l-5.39-9.33Zm-4.16 14.42h-2.44v-3.93H7.04v-2.37h3.74V6.91h2.44v3.88h3.74v2.37h-3.74v3.93Z" />
  </>,
  'CreateIcon',
);
